const BBPS_MOBILE_PREPAID_BILLERS = ['BSNL00000NATHL'];

export const isBBPSMobilePrepaidBiller = (billerId) => {
  if (BBPS_MOBILE_PREPAID_BILLERS.indexOf(billerId) >= 0) {
    return true;
  }
  return false;
};

export const getCustomerParamsMobilePrepaid = (rechargePlanDetails, mobileNumber) => {
  let customerParams = {};
  if (isBBPSMobilePrepaidBiller(rechargePlanDetails?.operatorId)) {
    customerParams['Mobile Number'] = mobileNumber;
    customerParams['Circle'] = rechargePlanDetails?.circleName;
    customerParams['Id'] = rechargePlanDetails?.planId;
  } else {
    customerParams['MobileNumber'] = mobileNumber;
    customerParams['CircleRefID'] = rechargePlanDetails?.circleId;
    customerParams['OperatorCode'] = rechargePlanDetails?.operatorId;
  }
  return customerParams;
};

export const frameMobilePrepaidRechargeRoutePath = (billDetails) => {
  let routePath = "";
  let mobileNumber = "";
  let circle = "";
  let operatorId = "";
  if (isBBPSMobilePrepaidBiller(billDetails?.billerPayuId)) {
    mobileNumber = billDetails?.customerParams.find(param => param.paramName === 'Mobile Number').value;
    circle = billDetails?.customerParams.find(param => param.paramName === 'Circle').value;
    operatorId = billDetails.billerPayuId;
  } else {
    mobileNumber = billDetails?.customerParams.find(param => param.paramName === 'MobileNumber').value;
    circle = billDetails?.customerParams.find(param => param.paramName === 'CircleRefID').value;
    operatorId = billDetails?.customerParams.find(param => param.paramName === 'OperatorCode').value;    
  }
  routePath = `/recharge/${operatorId}/${circle}/plan?mobileNumber=${mobileNumber}`;
  return routePath;
};